import { LOCATION_CHANGE } from 'react-router-redux';
import { CustomCategoryManagementActions } from '../actions';
import type { ICustomCategoryManagementState } from '../appstate';
import type { ICustomCategory } from '../domain';
import type { ICustomCategoryForMaintenance } from '../values';
import * as GeneralReducers from './GeneralReducers';

export const initialState: ICustomCategoryManagementState = {
	customCategories: {
		payload: [],
		inProcess: false,
		error: false,
	},
	customCategoryFromServer: {
		payload: undefined,
		inProcess: false,
		error: false,
	},
	customCategoryFromUser: undefined,
	creatingCategory: {
		payload: undefined,
		inProcess: false,
		error: false,
	},
	editingCategory: {
		payload: undefined,
		inProcess: false,
		error: false,
	},
	deleteCustomCategory: {
		inProcess: false,
		error: false,
	},
};

export const _childReducers = {
	customCategoriesReducer: GeneralReducers.CreateLoaderReducer<
		ICustomCategoryForMaintenance[]
	>({
		startAction: CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORIES,
		clearPayloadWith: initialState.customCategories.payload,
	}),
	customCategoryReducer: GeneralReducers.CreateLoaderReducer<ICustomCategory>({
		startAction: CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORY,
		clearPayloadWith: initialState.customCategoryFromServer.payload,
	}),
	creatingCustomCategory: GeneralReducers.CreateLoaderReducer<boolean>({
		startAction: CustomCategoryManagementActions.SUBMIT_NEW_CATEGORY,
		clearPayloadWith: initialState.creatingCategory.payload,
	}),
	editingCustomCategory: GeneralReducers.CreateLoaderReducer<boolean>({
		startAction: CustomCategoryManagementActions.SUBMIT_EDIT_CATEGORY,
		clearPayloadWith: initialState.editingCategory.payload,
	}),
	deleteCustomCategoryReducer: GeneralReducers.CreateAsynchronousActionReducer({
		startAction: CustomCategoryManagementActions.DELETING_CUSTOM_CATEGORY,
	}),
};

export function customCategoryManagementReducer(
	state = initialState,
	action
): ICustomCategoryManagementState {
	switch (action.type) {
		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORIES:
		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORIES_SUCCESS:
		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORIES_ERROR:
			return {
				...state,
				customCategories: _childReducers.customCategoriesReducer(
					state.customCategories,
					action
				),
			};

		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORY:
		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORY_SUCCESS:
		case CustomCategoryManagementActions.LOADING_CUSTOM_CATEGORY_ERROR:
			return {
				...state,
				customCategoryFromServer: _childReducers.customCategoryReducer(
					state.customCategoryFromServer,
					action
				),
			};

		case CustomCategoryManagementActions.SET_CUSTOM_CATEGORY:
			return {
				...state,
				customCategoryFromUser: action.payload,
			};

		case CustomCategoryManagementActions.SUBMIT_NEW_CATEGORY:
		case CustomCategoryManagementActions.SUBMIT_NEW_CATEGORY_SUCCESS:
		case CustomCategoryManagementActions.SUBMIT_NEW_CATEGORY_ERROR:
			return {
				...state,
				creatingCategory: _childReducers.creatingCustomCategory(
					state.creatingCategory,
					action
				),
			};

		case CustomCategoryManagementActions.SUBMIT_EDIT_CATEGORY:
		case CustomCategoryManagementActions.SUBMIT_EDIT_CATEGORY_SUCCESS:
		case CustomCategoryManagementActions.SUBMIT_EDIT_CATEGORY_ERROR:
			return {
				...state,
				editingCategory: _childReducers.editingCustomCategory(
					state.editingCategory,
					action
				),
			};

		case CustomCategoryManagementActions.DELETING_CUSTOM_CATEGORY:
		case CustomCategoryManagementActions.DELETING_CUSTOM_CATEGORY_SUCCESS:
		case CustomCategoryManagementActions.DELETING_CUSTOM_CATEGORY_ERROR:
			return {
				...state,
				deleteCustomCategory: _childReducers.deleteCustomCategoryReducer(
					state.deleteCustomCategory,
					action
				),
			};

		case LOCATION_CHANGE:
			return initialState;
	}
	return state;
}
